import clsx from "clsx";
import { ChangeEvent } from "react";

interface Props {
  value?: string;
  onChange?: (ev: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  label?: string;
  placeholder?: string;
  className?: string;
  containerClassName?: string;
  spRows?: number;
  maxLength?: number;
}

/**
 * 検索用テキストボックス
 */
export default function SearchField({
  value,
  onChange,
  label,
  placeholder,
  className,
  containerClassName,
  spRows = 2,
  maxLength,
}: Props) {
  const styles = {
    wrap: "flex flex-col",
    label: "text-sm",
    input: `block py-3 md:py-2 pr-1 md:py-[7px] pl-9 w-full bg-[left_8px_top_12px] md:bg-[left_8px_center] bg-no-repeat leading-normal ${
      className ? className : ""
    }`,
  };

  return (
    <div className={clsx("flex flex-col w-full md:w-auto", containerClassName)}>
      {label && <label className={styles.label}>{label}</label>}
      <div className="hidden md:block">
        <input
          type="search"
          className={styles.input}
          style={{ backgroundImage: "url('/user/icon/search.svg')" }}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          maxLength={maxLength}
        />
      </div>
      <div className="block md:hidden">
        <textarea
          name="search"
          className={styles.input}
          wrap="soft"
          rows={spRows}
          style={{ backgroundImage: "url('/user/icon/search.svg')" }}
          value={value}
          onChange={onChange}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              return false;
            }
          }}
          placeholder={placeholder}
        />
      </div>
    </div>
  );
}
